exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav-tabs > li {\r\n  cursor: pointer;\r\n  padding:10px;\r\n}\r\n\r\n.nav-tabs>li.active {\r\n  border-top: 0 !important;\r\n  border-bottom: 3px solid #04aeff;\r\n  font-weight:bold;\r\n}\r\n.disabled {\r\n  pointer-events: none;\r\n  cursor: crosshair;\r\n  opacity: 0.5;\r\n}\r\n\r\n.list-group-item {\r\n  border-bottom: none;\r\n}\r\n\r\n.list-group-item > .form-group {\r\n  margin-bottom: 0;\r\n}\r\n\r\nli:active, a:active, .active:active, li:focus, a:focus, .active:focus {\r\n  outline: none;\r\n}\r\n.segment{\r\n  margin-top: 31px !important;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Biziclick/bizisystem/src/app/main/pages/organization-detail/organization-detail.component.css
// module id = ../../../../../src/app/main/pages/organization-detail/organization-detail.component.css
// module chunks = main